module.exports = __webpack_public_path__ + "img/android_bro.43ab23d3.png";